import { useEffect, useRef } from "react";
import cls from "classnames";

import CountryCodeSelector from "./CountryCodeSelector";

function PhoneInput({
  phoneNumber,
  placeholder,
  onSubmit,
  handlePhoneNumberChange,
  handlePhoneNumberBlur,
  initialValue = "",
  error,
  selectedCountry,
  setSelectedCountry,
}) {
  const phoneNumberRef = useRef(null);

  useEffect(() => {
    const phoneNumberInput = phoneNumberRef.current;

    if (phoneNumberInput) {
      phoneNumberInput.focus();
    }
  }, [phoneNumberRef.current]);

  return (
    <form
      id="phone-input-form"
      className={cls(
        "overflow-hidden leading-8 text-xl flex items-center max-h-14 transition border-[1px] border-[#D5D8DC] px-4",
        "py-2 outline-none w-full rounded-[4px] h-auto mb-6"
      )}
      onSubmit={onSubmit}
    >
      <CountryCodeSelector
        selectedCountry={selectedCountry}
        setSelectedCountry={setSelectedCountry}
        className={cls("outline-none flex items-center", "text-[#16191B] text-base pr-2")}
      />
      <input
        className={cls(
          "w-full border-l-[1px] focus:outline-none text-base pl-3",
          "bg-white text-[#16191B] placeholder-[#A9B1B6]"
        )}
        ref={phoneNumberRef}
        type="tel"
        value={initialValue || phoneNumber}
        placeholder={placeholder || "9876543210"}
        onChange={handlePhoneNumberChange}
        onBlur={handlePhoneNumberBlur}
        maxLength="15"
      />
    </form>
  );
}

export default PhoneInput;
